// ---------------------------------------------------------------------------
// IMPORTANT!!
// This cleanup logic is not used because the header exists outside of the
// Barba container, meaning this logic should run only once on projects
// that have page transitions.
// ---------------------------------------------------------------------------

export default function initHeader() {
    const body = document.body;
    const nav = document.querySelector('.nav-closed');
    const navButton = document.querySelector('.mobile-nav-button') as HTMLButtonElement | null;
    const navLinks = Array.from(
        document.querySelectorAll('.nav-closed a')
    ) as HTMLAnchorElement[];
    const bars = [
        document.querySelector('.bar1'),
        document.querySelector('.bar2'),
        document.querySelector('.bar3'),
    ].filter((bar) => bar !== null);
    const header = document.querySelector('#header') as HTMLDivElement;

    // toggle nav open/closed
    function setNavOpen(isOpen: boolean) {
        nav?.classList.toggle('open', isOpen);
        navButton?.setAttribute('aria-expanded', String(isOpen));
        bars.forEach((bar) => bar.classList.toggle('change', isOpen));
    }

    function onNavButtonClick() {
        const nextState = !nav?.classList.contains('open');
        setNavOpen(Boolean(nextState));
    }

    // close nav when clicking outside
    function onBodyClick(e: PointerEvent) {
        const target = e.target as Element | null;

        const isNavButton = target?.closest('.mobile-nav-button');
        const isInsideNav = target?.closest('.nav-closed');

        if (!isNavButton && !isInsideNav && nav?.classList.contains('open')) {
            setNavOpen(false);
        }
    }

    function onNavLinkClick() {
        if (window.innerWidth < 992) {
            setNavOpen(false);
        }
    }

    // swap tactile/desktop class based on viewport width
    function updateHeaderClass() {
        if (!header) return;
        const isMobile = window.innerWidth < 992;
        header.classList.toggle('tactile', isMobile);
        header.classList.toggle('desktop', !isMobile);

        if (!isMobile) {
            setNavOpen(false);
        }
    }

    function onResize() {
        updateHeaderClass();
    }

    navButton?.addEventListener('click', onNavButtonClick);
    navLinks.forEach((link) => link.addEventListener('click', onNavLinkClick));
    body.addEventListener('click', onBodyClick);
    window.addEventListener('resize', onResize);

    // run once on init to set initial state
    onResize();

    return function cleanup() {
        navButton?.removeEventListener('click', onNavButtonClick);
        navLinks.forEach((link) => link.removeEventListener('click', onNavLinkClick));
        body.removeEventListener('click', onBodyClick);
        window.removeEventListener('resize', onResize);
    };
}
